// src/services/invitedClubsServices.js
import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/invited-clubs`;
const token = localStorage.getItem("token");

// Helper : récupère le userId courant depuis localStorage
export const getCurrentUserId = () => {
  const userItem = localStorage.getItem("userInfo");
  if (!userItem) return null;
  try {
    const user = JSON.parse(userItem);
    return user?.userId ?? null;
  } catch {
    return null;
  }
};

/// GET
// Récupère tous les clubs d'un user (tableau simple, pas de pagination)
export const getInvitedClubsByUser = async (userIdParam) => {
  const userId = userIdParam ?? getCurrentUserId();
  if (!userId) {
    console.error("getInvitedClubsByUser: userId manquant");
    return [];
  }

  try {
    const res = await axios.get(`${apiUrl}/${userId}/allClubs`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    // ← le contrôleur renvoie un tableau brut
    return res.data || [];
  } catch (error) {
    console.error("Erreur lors du chargement des clubs invités:", error);
    return [];
  }
};

/// POST
// Création d’un club (nom_club requis). user_id pris du localStorage si absent.
export const createInvitedClub = async ({
  nom_club,
  mail_club,
  tel_club,
  user_id,
}) => {
  const uid = user_id ?? getCurrentUserId();
  if (!nom_club || !uid) {
    throw new Error("nom_club et user_id sont requis");
  }

  try {
    const res = await axios.post(
      `${apiUrl}`,
      { nom_club, mail_club, tel_club, user_id: uid },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  } catch (error) {
    console.error("Erreur création club invité:", error?.response?.data || error);
    throw error;
  }
};

/// PUT
// Mise à jour d’un club par son id
export const updateInvitedClub = async (clubId, payload) => {
  if (!clubId) throw new Error("clubId requis");
  try {
    const res = await axios.put(`${apiUrl}/${clubId}`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    console.error("Erreur mise à jour club invité:", error?.response?.data || error);
    throw error;
  }
};

/// DELETE
// Suppression d’un club par son id
export const deleteInvitedClub = async (clubId) => {
  if (!clubId) throw new Error("clubId requis");
  try {
    const res = await axios.delete(`${apiUrl}/${clubId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data; // { success: true }
  } catch (error) {
    console.error("Erreur suppression club invité:", error?.response?.data || error);
    throw error;
  }
};

// Suppression multiple : body { ids: number[] }
export const bulkDeleteInvitedClubs = async (ids = []) => {
  if (!Array.isArray(ids) || ids.length === 0) {
    throw new Error("ids[] requis");
  }
  try {
    const res = await axios.delete(`${apiUrl}`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { ids },
    });
    return res.data; // { success: true, deleted: <nb> }
  } catch (error) {
    console.error("Erreur suppression multiple clubs invités:", error?.response?.data || error);
    throw error;
  }
};
